<!-- =========================================================================================
  File Name: ECommerceShop.vue
  Description: eCommerce Shop Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="main-container">
    <div class="vx-row mt-5 mb-2">
      <div class="vx-col w-full mb-1">
        <h5>Analysis for book/title: <b>{{ cyclopediaHelpers.getPreferredName(analysis.cyclopedia) }} (ID: {{ analysis.cyclopedia.id }})</b></h5>
      </div>
    </div>
    <div class="vx-row mt-5 mb-2">
      <div class="vx-col w-full mb-1">
        <span class="h1 float-left">{{ analysisHelpers.getPreferredName(analysis) }} (ID: {{ analysis.id }})</span>
        <span class="float-left"><vs-button type="line" @click="showAnalysisLocalizationsDialogFlag = true" color="primary" icon="edit" >Name/Localizations</vs-button></span>
        <vs-button class="ml-auto" color="danger" icon="delete_outline" type="gradient" @click="confirmDeleteAnalysis">Delete Analysis</vs-button>
      </div>
    </div>


    <div class="vx-row mt-1">
      <div class="vx-col w-full mb-1">
          <CategoriesListCard :analysis="analysis"></CategoriesListCard>
      </div>
    </div>

    <vs-prompt
      buttons-hidden
      :title="analysisHelpers.getPreferredName(analysis)"
      :active.sync="showAnalysisLocalizationsDialogFlag">
      <div class="modal-lg">
        <AnalysisLocalizationsCard :analysis="analysis"
                                     v-on:analysisUpdated="updateAnalysis"
        ></AnalysisLocalizationsCard>
      </div>
    </vs-prompt>
<!--    <div class="mt-5" v-html="jsonHtml.toHtml(cyclopedia)"></div>-->
  </div>
</template>

<script>
  import api from '@/http/api';
  import types from '@/models';
  import jsonHtml from '@/misc/jsonHtmlPrinter'
  import {cyclopediaHelpers, cyclopediaAnalysisHelpers} from '@/models/helpers'
  import CategoriesListCard from './CategoriesListCard';
  import AnalysisLocalizationsCard from './AnalysisLocalizationsCard';

  export default {
    components: {
      CategoriesListCard,
      AnalysisLocalizationsCard,
    },
    mounted() {
      this.fetchAll();
    },
    data() {
      return {
        jsonHtml: jsonHtml,
        isLoading: false,
        showAnalysisLocalizationsDialogFlag: false,
        cyclopediaHelpers: cyclopediaHelpers,
        analysisHelpers: cyclopediaAnalysisHelpers,
        analysis: new types.CyclopediaAnalysis(),
      }
    },
    computed: {
      analysisId() {
        return this.$route.query.id || null;
      },
    },
    watch: {
      isLoading(oldVal, newVal) {
        if (!newVal) {
          this.$vs.loading();
        } else {
          this.$vs.loading.close();
        }
      }
    },
    methods: {
      fetchAll() {
        this.isLoading = true;
        Promise.all([
          this.fetchAnalysis(),
        ]).then(() => {
          this.isLoading = false;
        });
      },
      async fetchAnalysis() {
        this.analysis = await api.fetchAnalysis(this.analysisId);
      },
      async updateAnalysis(analysis) {
        this.analysis = analysis;
        this.showAnalysisLocalizationsDialogFlag = false;
      },
      confirmDeleteAnalysis() {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          acceptText: 'DELETE',
          title: `DELETE ${this.analysis.name}`,
          text: `Are you sure you want to delete this analysis?`,
          accept: () => {
            this.deleteAnalysis(this.analysis);
          }
        })
      },
      async deleteAnalysis() {
        const success = api.deleteAnalysis(this.analysis);
        if (!success) {
          this.showNotification(false, 'error deleting analysis');
          return;
        }

        this.showNotification(true, `Analysis "${this.analysis.name}" Deleted`);
        this.$router.push(`/content/books/list`).catch(() => {
        });
      },
      showNotification(success, message) {
        this.$vs.notify({
          title: success ? 'Success' : 'Error',
          text: message ? message : '',
          color: success ? 'success' : 'danger',
          icon: success ? 'check_circle_outline' : 'error'
        });
      },
    },
  }

</script>


<style lang="scss">

</style>

